import { render } from "./ObjectsView.vue?vue&type=template&id=39cef746&scoped=true"
import script from "./ObjectsView.vue?vue&type=script&lang=js"
export * from "./ObjectsView.vue?vue&type=script&lang=js"

import "./ObjectsView.vue?vue&type=style&index=0&id=39cef746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cef746"]])

export default __exports__